<template>
  <!-- ##合作伙伴 -->
  <div id="partners">
    <page-banner title="合作伙伴" content="战略合作伙伴，共同打造"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
        <v-breadcrumb-item to="/partners">合作伙伴</v-breadcrumb-item>
      </v-breadcrumb>
    </div>
    <div class="companys">
      <p class="content-title">感谢以下合作伙伴</p>
      <div class="partner-list">
        <ul>
          <!--     可以采用  v-on:mouseenter    -->
          <li v-for="item in partners" :key="item.info.partnername">
            <img :src="item.info.path" alt>
            <p>{{item.info.partnername}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style scoped>
#partners {
  width: 100%;
  height: 100%;
  min-height: 800px;
}
.companys {
  width: 1000px;
  /* height: 400px; */
  margin: 0 auto;
}
.partner-list,
.partner-list ul {
  padding-top: 20px;
  /* height: 300px; */
  overflow: hidden;
}
.partner-list li {
  width: 250px;
  /* height: 50px; */
  float: left;
  line-height: 50px;
  text-align: center;
}
</style>
<script>
export default {
  name: "partners",
  data() {
    return {
      partners: [{
        info: {
          partnername: "华为技术有限公司",
          path: require("../assets/2017122810233270.jpg")
        }
      }]
      /** 合作伙伴信息 */
      // partners: [
      //   {
      //     company_name: "华为技术有限公司",
      //     logo: require("../assets/2017122810233270.jpg")
      //   },
      //   {
      //     company_name: "广州市纳星电子设备有限公司",
      //     logo: require("../assets/2017122810231592.jpg")
      //   },
      //   {
      //     company_name: "广州市良星电子设备有限公司",
      //     logo: require("../assets/2017122810204685.jpg")
      //   },
      //   {
      //     company_name: "广州市海珠区教育局",
      //     logo: require("../assets/2019082632009816.jpg")
      //   }
      // ]
    };
  },
  methods: {},
  mounted() {
    var self = this;
    this.ajax("/partnermanage.php", "get", null, function(data) {
			var data = JSON.parse(data);
			for(let i=0;i<data.length;i++){
				data[i].info = JSON.parse(data[i].info);
			}
			self.partners = data;
    });
  }
};
</script>







// WEBPACK FOOTER //
// src/components/partners-content.vue